import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { DeferredImage } from './DeferredImage';

import css from './BackgroundImage.scss';

export class BackgroundImage extends PureComponent {
  constructor(...args) {
    super(...args);
    this.renderImage = this.renderImage.bind(this);
  }

  renderImage({ style, imageUrl, ref }) {
    const {
      children,
      disablePreview,
      extraBackgroundClass,
      previewSize,
      previewQuality,
      url,
      ...extraProps
    } = this.props;

    return (
      <div className={css.base} ref={ref}>
        <div
          {...extraProps}
          className={cx(css.background, extraBackgroundClass)}
          style={{
            ...style,
            backgroundImage: imageUrl && `url(${imageUrl})`,
          }}
        />
        <div className={css.content}>{children}</div>
      </div>
    );
  }

  render() {
    const { disablePreview, disableDeferred, previewSize, previewQuality, url } = this.props;

    return (
      <DeferredImage
        disableDeferred={disableDeferred}
        disablePreview={disablePreview}
        previewSize={previewSize}
        previewQuality={previewQuality}
        url={url}>
        {this.renderImage}
      </DeferredImage>
    );
  }
}

BackgroundImage.propTypes = {
  children: PropTypes.node,
  disableDeferred: PropTypes.bool,
  disablePreview: PropTypes.bool,
  extraBackgroundClass: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),
  previewSize: PropTypes.number,
  previewQuality: PropTypes.number,
  url: PropTypes.string,
};
